import { ProductType as IProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';
import { createAction, props } from '@ngrx/store';

export const setActive = createAction(
  '[MOO/MODAL/Product Type] Set Active Entity',
  props<{ productTypeId: number }>(),
);

export const fetch = createAction(
  '[MOOE/MODAL/Product Type] Fetch start',
);

export const fetchSuccess = createAction(
  '[MOO/MODAL/Product Type] Fetch success',
  props<{ payload: IProductType[] }>(),
);

export const fetchFailed = createAction(
  '[MOO/MODAL/Product Type] Fetch failed',
);

export const resetProductTypeState = createAction(
  '[MOO/MODAL/Product Type] Reset',
);

const ProductTypeActions = {
  setActive,
  fetch,
  fetchSuccess,
  fetchFailed,
  resetProductTypeState,
};

export default ProductTypeActions;
